import { render, staticRenderFns } from "./resizeBar.vue?vue&type=template&id=34974d8a&"
import script from "./resizeBar.vue?vue&type=script&lang=ts&"
export * from "./resizeBar.vue?vue&type=script&lang=ts&"
import style0 from "./resizeBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports